import { DismissButton } from '@shared/components';
import useFilters from '@shared/features/data-table-filters/hooks/useFilters';
import {
  makeElementClassNameFactory,
  makeRootClassName,
  StyleProps,
} from '@shared/utils';
import clsx from 'clsx';
import { ReactElement } from 'react';

export type ClearAllFiltersChipProps = StyleProps & {
  // add props here
};

const ROOT = makeRootClassName('ClearAllFiltersChip');
const el = makeElementClassNameFactory(ROOT);

const DEFAULT_PROPS = {} as const;

export function ClearAllFiltersChip(
  props: ClearAllFiltersChipProps
): ReactElement {
  const p = { ...DEFAULT_PROPS, ...props };

  const { clearAllFilters } = useFilters();

  return (
    <div className={clsx(ROOT, p.className)}>
      <span className={el`label`}>{'Clear All'}</span>
      <DismissButton
        onPress={clearAllFilters}
        size="xs"
        className={el`clear-button`}
      />
    </div>
  );
}
export default ClearAllFiltersChip;
